import { pick } from "lodash";
import React from "react";
import useDesignExport from "../../hooks/query/useExportedDesigns";
import Modal from "../base/Modal";
import SubviewError from "../SubviewError";
import LoadingExportsView from "./LoadingExportsView";
import RecordsTable from "./RecordsTable";
import styles from "./ExportedDesignsModal.module.css";

const ExportedDesignsModal = (props) => {
  const { isError, isLoading, data, error } = useDesignExport({ enabled: true });

  const renderContentArea = () => {
    if (isError) {
      return <SubviewError showCloseBtn={false} error={error} />;
    }

    if (isLoading) {
      return <LoadingExportsView />;
    }

    return <RecordsTable records={data || []} />;
  };

  const modalProps = pick(props, Modal.BASIC_PROPS);

  return (
    <Modal {...modalProps}>
      <Modal.Dialog>
        <Modal.Dialog.Header closeButton>
          <Modal.Dialog.Title>Shared Designs</Modal.Dialog.Title>
        </Modal.Dialog.Header>
        <Modal.Dialog.Body className={styles["modal-body"]}>
          {renderContentArea()}
        </Modal.Dialog.Body>
      </Modal.Dialog>
    </Modal>
  );
};

export default ExportedDesignsModal;
